export default __webpack_public_path__ + "static/media/warning-triangle-yellow.743d50a2.svg";